export function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join("&");
}
//# sourceMappingURL=url.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appsignal/core/dist/esm/utils/url.js
// module id = 1234
// module chunks = 0